import React, { useContext, useEffect, useState } from "react";
import { StoreContext } from "../../../store";

import ReactDOM from "react-dom";
import Modal from "react-modal";
import Image from "react-bootstrap/Image";
import { SaveProductWithUpload, DeleteFile } from "../../../actions";
import Dropdown from "react-dropdown";
import ImageModal from "./ImageModal";
const qs = require("query-string");
//test
const labelStyle = {
  width: "100px",
  textAlign: "right",
  margin: "10px",
};

const inputStyle = {
  width: "300px",
  textAlign: "right",
  margin: "10px",
  // border: ".5px solid red",
};

const inputRowStyle = {
  // border: "1px solid blue",
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "center",
};

const customStyles = {
  content: {
    width: "90%",
    height: "90%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
  },
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

let UploadBirdModal = (props) => {
  //const parsed = qs.parse(window.location);

  const { dispatch, AuthToken, BaseURL } = useContext(StoreContext);

  const [modalIsOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [sex, setSex] = useState({ value: 0, label: "-" });
  const [sortingIndex, setSortingIndex] = useState(0);

  const formData = {
    GUID: "",
    Title: "",
    Description: "",
    Sex: "",
    Price: "",
    FileData: "",
    AccountID: "",
    Page: "",
    RedHeader:""
  };

  const post = props.FormData;
  const [FormData, setFormData] = useState(formData);
  const [fileData, setFileData] = useState("");
  const [fileDataPedigree, setFileDataPedigree] = useState("");
  const [page, setPage] = useState({ value: 0, label: "-" });
  const [files, setFiles] = useState();
  const [bird, setBird] = useState();
  const [redHeader,setRedHeader] = useState("");

  const destinationList = [
    { value: 0, label: "-" },
    { value: 1, label: "importbirds" },
    { value: 2, label: "usbirds" },
    { value: 3, label: "forsale" },
    { value: 4, label: "landingspot" },
  ];

  useEffect(() => {
    if (modalIsOpen) {
      const x = destinationList.find(
        (item) => item.label == window.location.pathname.replace("/", "")
      );
      setPage(x);
    }

    if (modalIsOpen && props.Bird !== undefined) {
      setPage(destinationList.find((item) => props.Bird.Page == item.label));
      setTitle(props.Bird.Title);
      setDescription(props.Bird.Description);
      setFiles(props.Bird.Files);
      setRedHeader(props.Bird.RedHeader);
      const s = props.Bird.Sex;
      setSex(
        s == 1
          ? { value: 1, label: "cock" }
          : s == 2
          ? { value: 2, label: "hen" }
          : { value: 0, label: "-" }
      );
      setPrice(props.Bird.Price);
      setSortingIndex(props.Bird.SortingIndex);
    }
  }, [modalIsOpen]);

  // useEffect(() => {
  //   alert(page.label);
  // }, [page]);

  // useEffect(() => {
  //   console.log(props.Bird);
  // }, []);
  // useEffect(() => {
  //   if (props.Bird !== undefined) {
  //     const bird = props.Bird;
  //     console.log(JSON.stringify(bird));
  //     //set form data
  //     setTitle(bird.Title);
  //     setDescription(bird.Description);
  //     setSex(bird.Sex);
  //     // setPrice(bird.Price);
  //     // setFiles(bird.Files);
  //     // setPage(bird.Page);
  //   }
  // }, [title, description, sex]);

  let subtitle;

  function openModal() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  const UploadPedigree = (e) =>{

    e.preventDefault();
    const files = e.target.files ;// + '_pedigree';
    setFileDataPedigree(files);
  

  }


  const ReadFile = (e) => {
    e.preventDefault();
    const files = e.target.files;
    // for (var i = 0; i < files.length; i++) {
    //   console.log(files[i]);
    // }

    // file = sender.target.files[0];
    setFileData(files);
    // setFileName(file.name);
    // if (file.name.includes(".txt")) {
    //   fileReader = new FileReader();
    //   fileReader.onloadend = () => handleFileRead(sender);
    //   fileReader.readAsText(file);
    // } else {
    //   raceResult.FName = file.name;
    //   raceResult.FileData = file;
    //   PopulateRaceForm(raceResult, dispatch);
    // }
  };

  const onFileChangeHandler = (e) => {
    e.preventDefault();
    // const files = e.target.files;
    // for (var i = 0; i < files.length; i++) {
    //   console.log(files[i]);
    // }

    setFileData(e.target.files[0]);
    // const formData = new FormData();
    // formData.append("file", files);
    // fetch("http://localhost:8080/upload", {
    //   method: "post",
    //   body: formData,
    // }).then((res) => {
    //   if (res.ok) {
    //     console.log(res.data);
    //     alert("File uploaded successfully.");
    //   }
    // });
  };

  let handleSave = () => {
    if (!ValidateForm()) return;

    FormData.Title = title;
    FormData.Description = description;
    FormData.Sex = sex.value;
    FormData.SortingIndex = sortingIndex;
    FormData.RedHeader = redHeader;
    FormData.Price = price;
    FormData.FileData = fileData;
    FormData.FileDataPedigree = fileDataPedigree;
    FormData.Page = page.label;
    FormData.GUID = props.Bird?.GUID;
    //if (FormData.GUID == "") {
    SaveProductWithUpload(FormData, dispatch, AuthToken);
    //} else console.log("perform edit");

    handleClose();
  };

  const handleDeleteFile = (fname) => {
    handleClose();
    DeleteFile(dispatch, fname, AuthToken);
    setFiles(files.filter((item) => item != fname));
  };

  useEffect(() => {
    setFiles(files);
  }, [files]);

  const renderFiles = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {files
          //.filter((item) => item.includes("jpg"))
          ?.map((item,index) => {
            if (item.includes("jpg")) {
              return (
                <div id={'file_'+index} style={{ border: "1px solid black", display: "flex" }}>
                  <span
                    style={{ color: "red" }}
                    onClick={() => handleDeleteFile(item)}
                  >
                    Click To Delete
                  </span>
                  <Image
                    src={
                      BaseURL +
                      "/UploadedFiles/wingandaprayerloft/Catalog/" +
                      item
                    }
                    style={{ width: "auto", height: "100px" }}
                  />
                </div>
              );
            } else {
              return (
                <div style={{ border: "1px solid black" }}>
                  <span
                    style={{ color: "red" }}
                    onClick={() => handleDeleteFile(item)}
                  >
                    Click To Delete
                  </span>
                  {item}
                </div>
              );
            }
          })}
      </div>
    );
    // let displayedFileNames = files?.map((item) => {
    //   return item.split("_")[1];
    // });
    // return displayedFileNames?.map((item) => {
    //   return (
    //     <div>
    //       <span>{item}</span>
    //       <br></br>
    //       <button
    //         onClick={() => {
    //           alert(item);
    //         }}
    //       >
    //         Delete
    //       </button>
    //     </div>
    //   );
    // });
  };
  const ValidateForm = () => {
    let isValid = true;
    if (page.value == 0) {
      alert("You need to specify the destination page.");
      isValid = false;
    }

    return isValid;
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <div style={{ padding: "10px" }}>
      <button onClick={openModal}>{props.Text}</button>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2 ref={(_subtitle) => (subtitle = _subtitle)}>{props.Alt}</h2>
        <div
          style={{
            border: ".1px solid gray",
            borderRadius: "10px",
            color: "dodgerblue",
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            padding: "20px",
          }}
        >
          {(props.Bird?.GUID ===undefined) ? '':  
          <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Page:</label>
            </div>
            <div style={inputStyle}>
              <div style={{ width: "100%", textAlign: "left" }}>
                <Dropdown
                  options={destinationList}
                  onChange={(event) => setPage(event)}
                  placeholder="Select the Page"
                  value={page.label}
                />
              </div>
            </div>
          </div>}
                  
          <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Title:</label>
            </div>
            <div style={inputStyle}>
              <input
                type="text"
                style={{ width: "100%" }}
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              ></input>
            </div>
          </div>
          <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Red Header:</label>
            </div>
            <div style={inputStyle}>
              <input
                type="text"
                style={{ width: "100%" }}
                placeholder="Use for marking SOLD, PENDING etc"
                value={redHeader}
                onChange={(e) => setRedHeader(e.target.value)}
              ></input>
            </div>
          </div>
          <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Description:</label>
            </div>
            <div style={inputStyle}>
              <textarea
                style={{ width: "100%" }}
                rows={5}
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          {page.label !== "landingspot" ? (
            <div style={inputRowStyle}>
              <div style={labelStyle}>
                <label>Sex:</label>
              </div>
              <div style={inputStyle}>
                <div style={{ width: "100%", textAlign: "left" }}>
                  <Dropdown
                    options={[
                      { value: 0, label: "-" },
                      { value: 1, label: "cock" },
                      { value: 2, label: "hen" },
                    ]}
                    onChange={(event) => setSex(event)}
                    placeholder="Select an option"
                    value={sex.label}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {page.label == "forsale" ? (
            <div style={inputRowStyle}>
              <div style={labelStyle}>
                <label>Price:</label>
              </div>
              <div style={inputStyle}>
                <input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="Price"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                ></input>
              </div>
            </div>
          ) : null}
          <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Sort Index:</label>
            </div>
            <div style={inputStyle}>
              <input
                type="text"
                style={{ width: "100%" }}
                placeholder="Sort Index"
                value={sortingIndex}
                onChange={(e) => setSortingIndex(e.target.value)}
              ></input>
            </div>
          </div>
          {(files === undefined)?'' :  <div style={inputRowStyle}>
            <div style={labelStyle}>
              <label>Files:</label>
            </div>
            <div style={inputStyle}>{renderFiles(files)}</div>
          </div>}
         
          {/* <div style={inputRowStyle}>
            <span style={{ fontWeight: "bold", color: "red" }}>
              (To upload pedigree not in pdf format, rename the file by
              appending "_pedigree" in the file name. Ex: birdasdf_pedigree.jpg)
            </span>
          </div> */}
          <div style={inputRowStyle}>
            <label>Choose Bird Image</label>
          </div>
          <div style={inputRowStyle}>
            <input
              type="file"
              className="form-control"
              name="file"
              multiple
              onChange={(sender) => ReadFile(sender)}
              style={{ height: "50px", width:"300px" }}
            />
          </div>
          <div style={inputRowStyle}>
            <label>Choose Pedigree</label>
          </div>
          <div style={inputRowStyle}>
            <input
              type="file"
              className="form-control"
              name="file"
              multiple
              onChange={(sender) => UploadPedigree(sender)}
              style={{ height: "50px", width:"300px" }}
              
            />
          </div>
        </div>
        <div style={{ display: "flex", margin: "10px" }}>
          <div style={{ marginRight: "5px" }}>
            <input
              style={{ border: "1px solid black" }}
              type="button"
              onClick={() => handleClose()}
              value="Close"
            />
          </div>

          <div>
            <input
              style={{ border: "1px solid black" }}
              type="button"
              onClick={() => handleSave()}
              value="Save"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UploadBirdModal;
